import { Outlet } from 'react-router-dom';

import { DataSidebar } from '@/components/layout/Data/DataSidebar';

export function DataLayout() {
  return (
    <div className="flex flex-1 min-w-0 overflow-hidden">
      <DataSidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
